import React from 'react';
import './Modal.css';

const SettingsModal = ({ isOpen, onClose, settings, onSettingsChange }) => {
  if (!isOpen) return null;

  const handleToggleTraffic = () => {
    onSettingsChange({
      ...settings,
      showTraffic: !settings.showTraffic
    });
  };

  const handleOpacityChange = (e) => {
    onSettingsChange({
      ...settings,
      heatmapOpacity: parseFloat(e.target.value)
    });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Settings</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          <div className="settings-section">
            <h3>Map Display</h3>

            <div className="setting-item">
              <label className="setting-label">
                <input
                  type="checkbox"
                  checked={settings.showTraffic}
                  onChange={handleToggleTraffic}
                  className="setting-checkbox"
                />
                <span className="setting-text">
                  <strong>Show Traffic</strong>
                  <small>Display real-time traffic conditions on the map</small>
                </span>
              </label>
            </div>

            <div className="setting-item" style={{ marginTop: '1.5rem' }}>
              <label className="setting-label" style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                <span className="setting-text" style={{ marginBottom: '0.5rem' }}>
                  <strong>Heatmap Transparency</strong>
                  <small>Adjust the transparency of the hex heatmap layer</small>
                </span>
                <div style={{ display: 'flex', alignItems: 'center', width: '100%', gap: '1rem' }}>
                  <input
                    type="range"
                    min="0.1"
                    max="1.0"
                    step="0.05"
                    value={settings.heatmapOpacity}
                    onChange={handleOpacityChange}
                    style={{ flex: 1 }}
                  />
                  <span style={{ minWidth: '50px', textAlign: 'right' }}>
                    {Math.round((1 - settings.heatmapOpacity) * 100)}%
                  </span>
                </div>
              </label>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button onClick={onClose} className="modal-button modal-button-primary">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingsModal;
